import { render, staticRenderFns } from "./AddStockChild.vue?vue&type=template&id=1b8bef34&scoped=true"
import script from "./AddStockChild.vue?vue&type=script&lang=js"
export * from "./AddStockChild.vue?vue&type=script&lang=js"
import style0 from "./AddStockChild.vue?vue&type=style&index=0&id=1b8bef34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8bef34",
  null
  
)

export default component.exports